import { GRAFANA_NET_DOMAIN } from './consts';
export const isInstanceUrl = (url: string | null) => (url ?? '').includes('.' + GRAFANA_NET_DOMAIN);
